import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useGetCategoryQuery } from "../../../features/api/categoryApi";
import { useEditProductMutation } from "../../../features/api/productApi";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../../components/baseUrl";

const UpdateSubItem = ({ product }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const { data } = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = data?.categories;

  const [cat_name, setCategory] = useState("");
  const [sub_catName, setSubCategory] = useState("");
  const [product_name, setProduct] = useState("");

  const [subCatByCat, setSubCatByCat] = useState([]);
  const [relode, setRelode] = useState(false);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/sub-categories/${cat_name}`)
      .then((res) => res.json())
      .then((data) => {
        setSubCatByCat(data?.subCategory);
        setRelode(!relode);
      });
  }, [cat_name]);

  const [updateProduct] = useEditProductMutation();
  const handleUpdate = async (id) => {
    try {
      const data = {
        id,
        cat_name: cat_name ? cat_name : product?.cat_name,
        sub_catName: sub_catName ? sub_catName : product?.sub_catName,
        product_name: product_name ? product_name : product?.product_name,
      };
      const response = await updateProduct(data);
      if (response?.error) {
        toast.error("Error...!!!");
      } else {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Update Successful...");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 ">
          <div className="bg-slate-200 p-6 rounded shadow-md lg:w-[40%]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col gap-4 w-full">
                    <div className="flex justify-between w-full">
                      <label className="w-[40%]">Category:</label>
                      <div className="w-full">
                        <input
                          type="text"
                          defaultValue={product?.category}
                          disabled
                          className="border pl-1 w-[50%] h-8 bg-slate-50"
                        />
                        <select
                          onChange={(e) => setCategory(e.target.value)}
                          className="border pl-1 w-[50%] h-8"
                        >
                          <option>--select--</option>
                          {categories?.map((category) => (
                            <option key={category?.id} value={category?.id}>
                              {category?.cat_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="flex justify-between w-full">
                      <label className="w-[40%]">Brand:</label>
                      <div className="w-full">
                        <input
                          type="text"
                          defaultValue={product?.subCategory}
                          disabled
                          className="border pl-1 w-[50%] h-8 bg-slate-50"
                        />
                        <select
                          onChange={(e) => setSubCategory(e.target.value)}
                          className="border pl-1 w-[50%] h-8"
                        >
                          <option>--select--</option>
                          {subCatByCat?.map((category) => (
                            <option key={category?.id} value={category?.id}>
                              {category?.sub_catName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="flex justify-between w-full">
                      <label className="w-[40%]">Product:</label>
                      <input
                        type="text"
                        defaultValue={product?.product_name}
                        onChange={(e) => setProduct(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => handleUpdate(product?.id)}
                    className="bg-green-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateSubItem;
